import {takeEvery, put, call, all, fork} from "redux-saga/effects"
import io from "socket.io-client";

import {
  SIO_URL,
} from "../../../common/config"

import {
  HEADER_SIO_INIT
} from "./actionTypes"

import {
  headerSioInitSuccess,
} from "./actions"

function* headerSioInit({payload: data}) {
  try {
    const sio = yield io(SIO_URL);
    yield put(headerSioInitSuccess(sio))
  } catch (error) {
    console.log(error)
  }
}

export function* watchHeaderSioInit() {
  yield takeEvery(HEADER_SIO_INIT, headerSioInit);
}

function* layoutHeaderSaga() {
  yield all([
    fork(watchHeaderSioInit),
  ]);
}

export default layoutHeaderSaga
